<span>

    <div id="example_info" role="status" aria-live="polite">
            <span *ngIf="!items || a == 1">Visualizzazione di {{a}} risultato</span>
            <span *ngIf="items && a != 1">Visualizzazione da {{da}} a {{a}} di <strong>{{items}}</strong> risultati</span>
    </div>

    <div *ngIf="numPages > 1" class="paginator">
        <a *ngIf="options.arrowsEnabled()" tabindex="0" (click)="setPage(options.getCurrentPage() - 1)">Precedente   </a>
        <a *ngIf="showLeftEllipsis" (click)="setPage(1)">1</a>
        <a *ngIf="showLeftEllipsis">...</a>
        
        <a *ngFor="let page of pages" tabindex="0" (click)="setPage(page)">{{page}}  </a>
        
        <a *ngIf="showRigthEllipsis">...</a>
        <a *ngIf="showRigthEllipsis" (click)="setPage(numPages)">{{numPages}}</a>
        <a *ngIf="options.arrowsEnabled()"  tabindex="0" (click)="setPage(options.getCurrentPage() + 1)">  Successivo</a>
    </div>

</span>